export default __webpack_public_path__ + "static/media/landing-bottom.93eccab9.webp";